<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content width="800px">
		<kaveh-form :key="ver" :entity="entity" :task="submit" />
	</kaveh-content>
</template>
<script>
	import { ProductGroup } from '@/modules/store/data/product-group/create'
	import { ProductGroupService } from '@/modules/store/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed: 
		{
			entity()
			{
				return ProductGroup
			},
			service()
			{
				return new ProductGroupService()
			},
		},
		methods:
		{
			async submit(payload)
			{
				try
				{
					const res = await this.service.create(payload);
					if (res.status == 200)
					{
						this.ver += 1
					}

				} catch (e) { console.log(e) }
			}
		}
	}
</script>